import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img src="https://onetvservices.me/hero-family-watching-tv.jpg" alt="Family watching TV" className="w-full h-full object-cover object-[70%_center] md:object-right" loading="eager" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/50" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/40" />
      </div>
      <div className="relative z-20 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 sm:pt-32 pb-8 sm:pb-16">
        <div className="max-w-4xl mx-auto">
          <div className="flex justify-center mb-4 sm:mb-6 animate-fade-in">
            <a href="/refund" className="inline-flex items-center gap-2 bg-emerald-500/20 border border-emerald-500/40 text-emerald-400 px-4 py-2 rounded-full text-xs sm:text-sm font-medium backdrop-blur-sm hover:bg-emerald-500/30 transition-colors cursor-pointer">
              <i className="ri-shield-check-line" /><span>{t('hero.badge')}</span>
            </a>
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-display font-bold mb-4 sm:mb-6 text-white tracking-tight leading-tight text-center animate-fade-in px-2">
            {t('hero.title1')}{' '}
            <span className="text-gradient block sm:inline">{t('hero.title2')}</span>
          </h1>
          <p className="text-sm sm:text-lg md:text-xl text-white/80 mb-6 sm:mb-10 text-center max-w-3xl mx-auto animate-fade-in px-4"
            spellCheck={false}
            dangerouslySetInnerHTML={{ __html: t('hero.desc') }} />
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mb-6 sm:mb-8 px-4 animate-fade-in">
            <a href="#test" className="group relative w-full sm:w-auto bg-gradient-to-r from-[#0284c7] to-[#0ea5e9] hover:from-[#0369a1] hover:to-[#0284c7] text-white font-bold text-base sm:text-lg px-6 sm:px-8 py-4 rounded-xl transition-all duration-300 hover:scale-105 overflow-hidden text-center whitespace-nowrap cursor-pointer">
              <span className="relative z-10">{t('hero.cta_primary')}</span>
              <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/20 to-transparent" />
            </a>
            <a id="btn_whatsapp" href="https://wa.me/12089746525" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 text-white font-semibold text-base sm:text-lg px-6 sm:px-8 py-4 rounded-xl border-2 border-white/20 hover:border-[#25D366] hover:bg-[#25D366]/10 hover:text-[#25D366] transition-all duration-300 text-center whitespace-nowrap cursor-pointer">
              <i className="ri-whatsapp-line text-xl" />
              {t('hero.cta_secondary')}
            </a>
          </div>
          <div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center sm:gap-8 mb-6 sm:mb-10 animate-fade-in">
            <div className="flex items-center gap-2 text-white/90">
              <div className="flex">{[1,2,3,4,5].map(i => <i key={i} className="ri-star-fill text-amber-400 text-sm" />)}</div>
              <span className="font-semibold text-sm sm:text-base">4.9/5</span>
              <span className="text-white/70 text-sm sm:text-base">{t('hero.rating_text')}</span>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2 sm:gap-4 md:grid-cols-4 max-w-3xl mx-auto animate-fade-in px-2">
            {[
              { icon: 'ri-gift-line', color: 'from-amber-400 to-orange-500', key: 'trial' },
              { icon: 'ri-tv-line', color: 'from-cyan-400 to-blue-500', key: 'channels' },
              { icon: 'ri-movie-2-line', color: 'from-sky-400 to-blue-500', key: 'vod' },
              { icon: 'ri-wifi-line', color: 'from-emerald-400 to-teal-500', key: 'stable' },
            ].map(({ icon, color, key }) => (
              <div key={key} className="glass-effect p-3 sm:p-5 rounded-lg sm:rounded-xl text-center group hover:scale-105 transition-all duration-300 cursor-default">
                <div className={`bg-gradient-to-r ${color} w-10 h-10 sm:w-14 sm:h-14 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-3 shadow-lg`}>
                  <i className={`${icon} text-white text-lg sm:text-2xl`} />
                </div>
                <p className="text-xs sm:text-sm font-semibold text-white leading-tight">{t(`hero.feature_${key}`)}</p>
              </div>
            ))}
          </div>
          <div className="mt-6 sm:mt-10 flex justify-center animate-fade-in px-2">
            <a href="#pricing" className="bg-gradient-to-r from-[#0284c7] to-[#0ea5e9] hover:from-[#0369a1] hover:to-[#0284c7] text-white font-semibold text-base sm:text-lg px-8 sm:px-12 py-4 sm:py-5 rounded-full hover:scale-[1.02] transition-all duration-300 cursor-pointer whitespace-nowrap">
              {t('hero.discover')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
